<div [id]="target"  [class]="mapContainerClass">
    <app-layerswitcher class="layerswitcher">
    </app-layerswitcher>
    <app-legend id='raster-legend' *ngIf="this.colorMap && this.colorMap.length > 5" class='legend-color-map' [rotate]="true" [width]="300" [height]="15" [colorMap]="this.colorMap ? this.colorMap : ''  ">
    </app-legend>
  </div>
